(()=>{
  const roots=document.querySelectorAll('[data-finect-wholesale]');
  roots.forEach(root=>{
    if(root.dataset.initialized==='true')return;
    root.dataset.initialized='true';
    const form=root.querySelector('[data-project-form]');
    const result=root.querySelector('[data-brief-result]');
    const brief=root.querySelector('[data-brief-text]');
    const status=root.querySelector('[data-brief-status]');
    if(!form||!result||!brief)return;
    const emailDraft=root.querySelector('[data-email-draft]');
    const updateEmail=()=>{emailDraft.href=`mailto:jimmyjames0622@gmail.com?subject=${encodeURIComponent('FINECT project enquiry — '+form.elements.model.value)}&body=${encodeURIComponent(brief.value)}`;};
    brief.addEventListener('input',updateEmail);
    form.addEventListener('submit',event=>event.preventDefault());
    root.querySelectorAll('[data-select-model]').forEach(link=>link.addEventListener('click',()=>{
      form.elements.model.value=link.dataset.selectModel;
      if(link.dataset.testTask)form.elements.task.value=link.dataset.testTask;
    }));
    root.querySelector('[data-build-brief]').addEventListener('click',()=>{
      if(!form.reportValidity())return;
      const val=name=>form.elements[name].value.trim();
      const body=[
        'Hello Jimmy,',
        'I would like to discuss a FINECT wholesale or customization project.',
        '',
        `Company: ${val('company')||'To be confirmed'}`,
        `Destination country: ${val('country')}`,
        `Channel: ${val('channel')}`,
        `Product: ${val('model')}`,
        `Estimated quantity: ${val('quantity')||'To be confirmed'}`,
        `Customization: ${val('customization')}`,
        `Target date: ${val('target_date')||'To be confirmed'}`,
        `Customer task / questions: ${val('task')||'Please help me compare suitable models.'}`,
        '',
        'Please confirm the configuration, sample charges and shipping,',
        'minimum quantity, production schedule and available documentation.'
      ].join('\n');
      brief.value=body;
      updateEmail();
      result.hidden=false;
      status.textContent='Your draft is ready. Nothing has been sent. Copy it or open your own email app.';
      result.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest'});
    });
    root.querySelector('[data-copy-brief]').addEventListener('click',async()=>{
      try{
        if(!navigator.clipboard)throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(brief.value);
        status.textContent='Brief copied. Send it using your preferred contact method.';
      }catch{
        brief.focus();brief.select();
        status.textContent='Brief selected. Copy it manually using your keyboard or device menu.';
      }
    });
  });
})();
